"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAcceptJS = initAcceptJS;
exports.initStripe = initStripe;
// Track whether scripts have been loaded
var acceptJSLoaded = false;
var acceptJSLoadPromise = null;
function initAcceptJS(ENV) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            console.log("Initializing Accept.js");
            // Return existing promise if script is currently loading
            if (acceptJSLoadPromise) {
                return [2 /*return*/, acceptJSLoadPromise];
            }
            // Check if already loaded via our flag or by checking the DOM
            if (acceptJSLoaded || document.querySelector('script[src*="authorize.net/v1/Accept.js"]')) {
                console.log("Accept.js already loaded, skipping duplicate load");
                acceptJSLoaded = true;
                return [2 /*return*/, Promise.resolve(true)];
            }
            // Check if the global Accept object already exists
            if (typeof window.Accept !== 'undefined') {
                console.log("Accept.js global object already exists, skipping load");
                acceptJSLoaded = true;
                return [2 /*return*/, Promise.resolve(true)];
            }
            // Create the loading promise
            acceptJSLoadPromise = new Promise(function (resolve, reject) {
                var src = ENV !== "production"
                    ? "https://jstest.authorize.net/v1/Accept.js"
                    : "https://js.authorize.net/v1/Accept.js";
                var script = document.createElement("script");
                script.setAttribute("src", src);
                script.setAttribute("data-accept-js", "true"); // Mark our script for easy identification
                script.onload = function () {
                    console.log("Accept.js loaded successfully");
                    acceptJSLoaded = true;
                    acceptJSLoadPromise = null; // Clear the promise
                    resolve(true);
                };
                script.onerror = function (error) {
                    console.error("Failed to load Accept.js:", error);
                    acceptJSLoadPromise = null; // Clear the promise so it can be retried
                    reject(new Error("Failed to load Accept.js"));
                };
                // Append to head instead of body for consistency
                document.head.appendChild(script);
            });
            return [2 /*return*/, acceptJSLoadPromise];
        });
    });
}
var stripeLoaded = false;
var stripeLoadPromise = null;
function initStripe(ENV) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            console.log("Initializing Stripe");
            // Return existing promise if script is currently loading
            if (stripeLoadPromise) {
                return [2 /*return*/, stripeLoadPromise];
            }
            // Check if already loaded via our flag or by checking the DOM
            if (stripeLoaded || document.querySelector('script[src*="js.stripe.com/v3"]')) {
                console.log("Stripe.js already loaded, skipping duplicate load");
                stripeLoaded = true;
                return [2 /*return*/, Promise.resolve(true)];
            }
            // Check if the global Stripe object already exists
            if (typeof window.Stripe !== 'undefined') {
                console.log("Stripe global object already exists, skipping load");
                stripeLoaded = true;
                return [2 /*return*/, Promise.resolve(true)];
            }
            // Create the loading promise
            stripeLoadPromise = new Promise(function (resolve, reject) {
                var src = "https://js.stripe.com/v3";
                var script = document.createElement("script");
                script.setAttribute("src", src);
                script.setAttribute("data-stripe-js", "true"); // Mark our script for easy identification
                script.onload = function () {
                    console.log("Stripe.js loaded successfully");
                    stripeLoaded = true;
                    stripeLoadPromise = null; // Clear the promise
                    resolve(true);
                };
                script.onerror = function (error) {
                    console.error("Failed to load Stripe.js:", error);
                    stripeLoadPromise = null; // Clear the promise so it can be retried
                    reject(new Error("Failed to load Stripe.js"));
                };
                // Append to head instead of body for consistency
                document.head.appendChild(script);
            });
            return [2 /*return*/, stripeLoadPromise];
        });
    });
}
